import {
    SUBMIT_PROCEDURE_DATA,
    SUBMIT_PROCEDURE_DATA_SUCCESS,
    SUBMIT_PROCEDURE_DATA_FAILURE,
    RESET_SUBMIT_PROCEDURE_DATA,
} from '../actions';

const initialState = {
    loading: false,
    statusCode: '',
    statusMessage: '',
    isSendReportReset: false,
};

const submitProcedureDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUBMIT_PROCEDURE_DATA:
            return {
                ...state,
                loading: true,
            };
        case SUBMIT_PROCEDURE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.data,
            };
        case SUBMIT_PROCEDURE_DATA_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case RESET_SUBMIT_PROCEDURE_DATA:
            return {
                ...state,
                statusCode: '',
                statusMessage: '',
            };
        default:
            return {
                ...state,
            };
    }
};

export default submitProcedureDataReducer;
